import React, { memo, useState } from 'react'
import { Collapse } from '@mantine/core'
import { IconMaps } from '@ow/icons'
import clsx from 'clsx'
import CardList from './cardList'

const Switcher = ({ open, onClick }) => {
  return (
    <div
      className="flex items-center gap-1 py-4 hover:opacity-80 cursor-pointer"
      onClick={() => onClick(!open)}
    >
      <span className="text-sm">{open ? '收起' : '展开'}</span>
      <div
        style={{
          transform: open ? 'none' : 'rotateX(180deg)',
        }}
      >
        <IconMaps type="foldUp" width={16} height={16} fill="#2d2d2d" />
      </div>
    </div>
  )
}

const Section = ({
  title = '项目列表',
  appList = [],
  defaultClose = false,
  underLine = true,
  itemClickHandler,
}) => {
  const [open, setOpen] = useState(!defaultClose)
  return (
    <div className={clsx(underLine && 'border-b', 'px-6', 'pb-6', 'mb-6')}>
      <div className="flex justify-between items-center">
        <h2>
          {title}（{appList.length}）
        </h2>
        <Switcher open={open} onClick={setOpen} />
      </div>
      <Collapse in={open}>
        <CardList list={appList} itemClickHandler={itemClickHandler} />
      </Collapse>
    </div>
  )
}

export default memo(Section)
